export default __webpack_public_path__ + "static/media/dti.ed727dbf.png";